import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'library-card',
  templateUrl: './library-card.component.html',
  styleUrls: ['./library-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibraryCardComponent {
  @Input() id = '';
  @Input() library = '';
  @Output() closed = new EventEmitter<any>();

  constructor() {}

  close() {
    this.closed.emit(true);
  }
}
